<template>
  <v-card title="开票申请查询">
     <v-modal
      title="提示信息"
      :visible="visible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
            <div v-html="message"></div>
      <!-- <p>{{ message }}</p> -->
          </v-modal
    >
    <div class="grid-demo">
       <v-more-panel>
        <v-form slot="form">

          <v-form-item label="申请日期">
            <v-date-picker v-model="options.ywrqq"></v-date-picker>
             -
            <v-date-picker v-model="options.ywrqz" ></v-date-picker>
          </v-form-item>

             <v-form-item label="业务单号"> 
             <v-input placeholder="" v-model="options.ywdh"></v-input>
            </v-form-item>

            <v-form-item label="UID"> 
             <v-input placeholder="" v-model="options.uid"></v-input>
            </v-form-item>

              <v-form-item label="联系人"> 
             <v-input placeholder="" v-model="options.lxr"></v-input>
            </v-form-item>

            <v-form-item label="联系电话"> 
             <v-input placeholder="" v-model="options.lxdh"></v-input>
            </v-form-item>
            
              <v-form-item label="企业税号"> 
             <v-input placeholder="" v-model="options.qysh"></v-input>
            </v-form-item>

            <v-form-item label="开票状态"
            >
            <v-radio-group v-model="options.kpzt" :data="kp_state" ></v-radio-group>
            </v-form-item>
            
        </v-form>
        <v-form-item
        <v-button slot="control" type="primary"  icon="search"  @click="findList('1')">查询</v-button>
        <v-button slot="control" type="error"  icon="delete"  @click="deleteInfo()">删除敏感信息</v-button>
        </v-form-item>
      </v-more-panel>
    </div>
    <br />
    <vxe-grid
      v-bind="xGridOptions"
      size="mini"
      stripe
      highlight-current-row
      highlight-hover-row
      ref="xTable"
      :data="tableData"
      :loading="loading"
      row-id="gh"
    >

       <!--自定义插槽 cz-->
      <template v-slot:cz="{ row }">
        <span>
          <span>
            <a class="link" @click="download(row)" title="下载">
              <!-- <v-icon type="download"></v-icon> -->下载发票
            </a>
            </v-popconfirm>
          </span>
        </span>
      </template>
      <template v-slot:empty>
        <span style="color: red">
          <p>未搜索到结果！</p>
        </span>
      </template>
    </vxe-grid>
    <vxe-pager
      :current-page="pagination.pageindex"
      :page-size="pagination.pagesize"
      :total="pagination.totalresult"
      :layouts="[
        'PrevPage',
        'JumpNumber',
        'NextPage',
        'FullJump',
        'Sizes',
        'Total',
      ]"
      @page-change="handlePageChange"
    ></vxe-pager>
  </v-card>
</template>
<script>
let options = {
  ywrqq:"",
  ywrqz:"",
  ywdh:"",
  uid:"",
  lxr:"",
  lxdh:"",
  qysh:"",
  kpzt:"0"
};
let pagination = {
  // sort: "gh",
  // sorttype: "desc",
  pagesize: 10,
  pageindex: 1,
  totalresult: 1
};

let kp_state = [{ value: '0', text: '全部' }, { value: '1', text: '未开票' }, { value: '2', text: '已开票' }];
export default {
  data() {
    return {
      kp_state,
      options,
      pagination,
      tableData: [],
      visible: false,
      loading:false,
      message: "",
      xGridOptions: {
        showOverflow: true,
        resizable: true,
        height: document.documentElement.clientHeight - 220,
        headerAlign: "center",
         toolbarConfig: {
         
          export: true,
          zoom: true,
          custom: true
        },
         exportConfig: {
          remote: true,
          exportMethod: this.exportMethod,
          types: ['xlsx'],
          modes: ['current']
        },
        columns: [
          {
            field: "rn",
            title: "序号",
            width: 70,
            align: "center"
          },

          {
            field: "ywdh",
            title: "业务单号",
            align: "center",
            width: 180
          },
          {
            field: "uid",
            title: "UID",
            align: "center",
             width: 160
          },
          {
            field: "sqrmc",
            title: "联系人",
            align: "center",
             width: 200
          },
          {
            field: "lxdh",
            title: "联系电话",
            align: "center",
             width: 120
          },
          {
            field: "qysh",
            title: "企业税号",
            align: "center",
             width: 200
          },
          
          {
            field: "sqryx",
            title: "申请人邮箱",
            align: "center",
             width: 200
          },
          {
            field: "sqsj",
            title: "申请时间",
            align: "center",
             width: 200
          },
          {
            field: "fkfsmc",
            title: "付款方式",
            align: "center",
             width: 160
          },
           {
            field: "je",
            title: "开票金额",
            align: "right",
             width: 120,
             formatter:"formatNumber"
          },
           {
            field: "kpztmc",
            title: "开票状态",
            align: "center",
             width: 200
          },
           {
            field: "fsztmc",
            title: "发送状态",
            align: "center",
             width: 200
          },
           {
            field: "fpdm",
            title: "发票代码",
            align: "center",
             width: 120
          },
           {
            field: "fphm",
            title: "发票号码",
            align: "center",
             width: 100
          },
            {
            field: "cz",
            title: "操作",
            align: "center",
             width: 80,
            slots: {
              // 对应自定义插槽的名称
              default: "cz",
            },
          },
        ]
      }
    };
  },
  created() {
    var date = new Date();
            // 转为中划线得同时判断，开始时间小于10月份前边+零，大于等于10月份取消前边+0；
    var taskStartTime;
    if (date.getMonth() < 9) {
        taskStartTime = date.getFullYear() + "-0" + (date.getMonth() + 1) + "-"
    } else {
        taskStartTime = date.getFullYear() + "-" + (date.getMonth() + 1) + "-"
    }
    if (date.getDate() < 10) {
        let day =date.getDate()
        if(day>1){
           taskStartTime += "0" + (date.getDate()-1)
        }else{
           taskStartTime += "0" + (date.getDate())
        }
       
    } else {
        taskStartTime += (date.getDate()-1)
    }
    debugger
    this.options.ywrqq =taskStartTime
    this.options.ywrqz = new Date().toLocaleDateString().replace('/','-').replace('/','-')
  },
  methods: {
    findList(index) {
      this.loading = true
      if (index == "1") {
        this.pagination.pageindex = 1;
      }
      this.$axios
        .get(
          "api/system/interface/kpsqcx?cx=" + JSON.stringify(this.options), { params: this.pagination }
        )
        .then(res => {
          // debugger
          this.tableData = res.data.data
          this.pagination.totalresult = res.data.total;
          this.loading = false
        });
    },
    async download(row){
      debugger
      if(row.kpztmc =='已开具'){
         try {  
        // 假设你的下载API是'/api/download'  
        const response = await this.$axios({  
          url: "api/system/interface/fp-xz?code="+row.fpdm+"&number="+row.fphm,  
          method: 'GET',  
          responseType: 'blob', // 重要：告诉axios期望的响应类型  
        });  
  
        // 创建一个Blob URL指向下载的文件  
        const url = window.URL.createObjectURL(new Blob([response.data]));  
  
        // 创建一个a标签来模拟点击下载  
        const link = document.createElement('a');  
        link.href = url;  
  
        // 设置下载文件的名称  
        // 注意：这里需要后端在响应头中通过Content-Disposition字段提供文件名，  
        // 或者你可以在这里硬编码文件名  
        if(row.fpdm=="" || row.fpdm == null || row.fpdm == undefined || row.fpdm=="null"){
          link.download = row.fphm+'.pdf';  
        }else{
          link.download = row.fpdm+'_'+row.fphm+'.pdf';  
        }
        
  
        // 模拟点击a标签  
        // document.body.appendChild(link);  
        link.click();  
  
        // 清理  
        document.body.removeChild(link);  
        window.URL.revokeObjectURL(url);  
      } catch (error) {  
        console.error('下载文件时出错:', error);  
      }  
      }
     
    },
   
   deleteInfo(){
     this.message = "确认删除敏感信息，操作后无法回退！"
     this.showModal()
    
   },
    handlePageChange({ currentPage, pageSize }) {
      this.pagination.pageindex = currentPage;
      this.pagination.pagesize = pageSize;
      this.findList();
    },

     showModal() {
      this.visible = true;
    },
    handleOk() {
      this.visible = false;
        this.$axios
        .get(
          "api/system/interface/mgxxsc?cx=" + JSON.stringify(this.options)
        )
        .then(res => {
          if(res.data.code == 200){
          // 
          this.$message["success"](res.data.message);
          
        }
        else{
           this.$message["error"](res.data.message);
        }
        });
      this.findList();
    },
    handleCancel() {
      this.visible = false;
    },
     formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    },
     exportMethod({ options }) {

       
      this.$axios({method:'get',url:'api/system/interface/export-file-kpsq?sheetname='+options.sheetName +'&cx=' + 
      JSON.stringify(this.options)+'&pageindex='+this.pagination.pageindex+'&pagesize='+this.pagination.pagesize, responseType:'blob'}).then((res) => {
        debugger
        let blob = new Blob([res.data], { type: "application/vnd.ms-excel;charset=utf-8;" });
        var downloadElement = document.createElement("a");
        var href = window.URL.createObjectURL(blob); //创建下载的链接
        downloadElement.href = href;
        downloadElement.download=options.filename+".xlsx"; //下载后文件名
        document.body.appendChild(downloadElement);
        downloadElement.click(); //点击下载
        document.body.removeChild(downloadElement); //下载完成移除元素
        window.URL.revokeObjectURL(href); //释放掉blob对象
       this.spinning = false

      });
     }
  }
};
</script>
<style>
</style>


// WEBPACK FOOTER //
// src/view/ywgl/kpsqcx.vue